<ng-container *ngIf="transaction$ | async as transaction">
    <ng-container *ngIf="transaction !== null && transaction.items?.length">
        <div class="row display-flex justify-content-center margin-top-1">
            <app-order-total></app-order-total>
        </div>
        <div class="row display-flex justify-content-center margin-top-1" *ngIf="transaction.pointsApplied > 0">
            {{ transaction.pointsApplied }} {{ 'LABEL_ORDER_POINTS_APPLIED' | translate }}
        </div>
    </ng-container>
</ng-container>
